import { Pipe, PipeTransform } from '@angular/core';
import { enumPaymentStatus } from '../models/enum-payment-status';

@Pipe({ name: 'paymentStatusLabel' })
export class PaymentStatusLabelPipe implements PipeTransform {
  transform(id: number, ...args: boolean[]): string {
    switch (id) {
      case enumPaymentStatus.PROCESSING:
        return 'In corso';
      case enumPaymentStatus.PAYED:
        return 'Pagato';
      case enumPaymentStatus.NOT_PAYED:
        return 'Non pagato';
    }
    return ``
  }
}